import React from 'react';
import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalCloseButton,
  ModalBody,
  ModalFooter,
  Button,
  Text,
  SimpleGrid,
  Box,
  Input,
  FormLabel,Select,
  InputGroup,
  InputLeftAddon,useDisclosure,
  Checkbox,
  

} from '@chakra-ui/react';
import { useState,useEffect } from 'react';
import { IoMdClose } from "react-icons/io";
import axios from 'axios'
import toast from 'react-hot-toast';
import { set } from 'lodash';

const TableOrderModal = ({ isOpen, onClose, tooltip }) => {
    return (
      <Modal
        width="full"
        size="3xl"
        isOpen={isOpen}
        onClose={onClose}
        scrollBehavior="inside"
      >
        <ModalOverlay />
        <ModalContent bg="#f9f1e3">
          <ModalHeader display="flex" justifyContent="space-between" alignItems="center">
            <Text>Table Data</Text>
            <Button colorScheme="red" onClick={onClose}>
              <IoMdClose />
            </Button>
          </ModalHeader>
          <ModalBody>
            <Text>{tooltip || "No data available"}</Text>
          </ModalBody>
          <ModalFooter></ModalFooter>
        </ModalContent>
      </Modal>
    );
  };
export default TableOrderModal;
